/**
 * Before Interceptor.
 */

module.exports = function (_) {

    return {

        request: function (request) {

            if (_.isFunction(request.beforeSend)) {
                request.beforeSend.call(this, request);
            }

            return request;
        }

    };

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/interceptor/before.js
// module id = 223
// module chunks = 1